import React, { Component, Fragment } from "react";
import Editor from "../editor/Editor";
import ChapterButton from "../../components/ChapterButton.js";
import SectionButton from "../../components/SectionButton.js";
import RoundButton from "../../components/RoundButton";
import { Route, withRouter } from "react-router-dom";
import themes from "../../themes";

class Book extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: "690px",
      loading: false,
      author: false
    };
  }
  componentDidMount = async () => {
    const { match, history, book } = this.props;
    if (history.action === "POP") {
      const location = {
        pathname: "/",
        state: {
          book: match.params.book,
          chapter: match.params.chapter,
          section: match.params.section
        }
      };
      history.push(location);
    }

    if (book) {
      const chapter = book.filter(each => each.title === match.params.chapter);
      const numSections = chapter[0].sections.length;
      if (numSections > 16 && numSections <= 32) {
        this.setState({ height: "630px" });
      } else if (numSections > 32 && numSections <= 48) {
        this.setState({ height: "570px" });
      }
    }
  };
  selectChap(chap, sec) {
    const { history, match } = this.props;
    const location = { pathname: `/${match.params.book}/${chap}/${sec}` };
    history.push(location);
  }
  selectSec(sec) {
    const { history, match } = this.props;
    const location = {
      pathname: `/${match.params.book}/${match.params.chapter}/${sec}`
    };
    history.push(location);
  }
  addSec = async (id, chap) => {
    const { match, utils, history } = this.props;
    await utils.fb.createSection(id, chap);
    const location = {
      pathname: "/",
      state: {
        book: match.params.book,
        chapter: match.params.chapter,
        section: match.params.section
      }
    };
    history.push(location);
  };
  removeSec = async (id, chap, sec) => {
    const { match, utils, history } = this.props;
    await utils.fb.deleteSection(id, chap, sec);
    const location = {
      pathname: "/",
      state: {
        book: match.params.book,
        chapter: match.params.chapter,
        section: match.params.section
      }
    };
    history.push(location);
  };
  render() {
    const { author } = this.state;
    const { match, book, utils, theme, history } = this.props;
    const back = theme === "dark" ? themes[0].base : themes[1].base;
    const Chaps = () => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "fixed",
          left: "80px",
          top: "20px"
        }}
      >
        {book.map(each => {
          let selected = each.title === match.params.chapter ? true : false;
          return (
            <Fragment key={each.title}>
              <ChapterButton
                key={each.title}
                selected={selected}
                theme={theme}
                onClick={() => this.selectChap(each.title, each.sections[0].id)}
              >
                {each.title}
              </ChapterButton>

              <Route
                key={each.sections[0].id}
                exact
                path={`/${match.params.book}/${each.title}/:section`}
                render={() => (
                  <div
                    style={{
                      position: "absolute",
                      width: "1000px",
                      minWidth: "400px",
                      paddingTop: "20px",
                      left: "200px",
                      top: "-20px"
                    }}
                  >
                    { book && each.sections.map((each, index) => {
                      let selected =
                        each.id === match.params.section ? true : false;
                      return (
                        <SectionButton
                          selected={selected}
                          theme={theme}
                          key={each.id}
                          onClick={() => this.selectSec(each.id)}
                        >
                          {index + 1}
                        </SectionButton>
                      );
                    })}
                    {author && (
                      <div>
                       <RoundButton
                        onClick={() =>
                          this.removeSec(
                            match.params.book,
                            match.params.chapter,
                            match.params.section
                          )
                        }
                        style={{
                          position: "fixed",
                          right: "70px",
                          top: "13px"
                        }}
                        theme={theme}
                      >
                        <i className="material-icons">remove</i>
                      </RoundButton>
                    
                    <RoundButton
                      onClick={() =>
                        this.addSec(match.params.book, match.params.chapter)
                      }
                      style={{ position: "fixed", right: "10px", top: "13px" }}
                      theme={theme}
                    >
                      <i className="material-icons">add</i>
                    </RoundButton> 
                    </div>
                    )}
                  </div>
                )}
              />
            </Fragment>
          );
        })}
      </div>
    );
    return (
      <div
        id="home"
        style={{
          height: this.state.height,
          left: "80px",
          display: "flex",
          position: "fixed",
          bottom: "0px"
        }}
      >
        {book && (
          <Fragment>
            <Chaps />
            <Editor
              utils={utils}
              match={match}
              history={history}
              theme={theme}
              book={book}
              author={author}
            />
          </Fragment>
        )}
      </div>
    );
  }
}
const BookWR = withRouter(Book);
export default BookWR;


// WEBPACK FOOTER //
// ./src/containers/book/Book.js